module.exports = __webpack_public_path__ + "img/rank_left.80008932.svg";